(() => {
  const LOOK_SELECTOR = ".look-card-image";
  const PIN_SELECTOR = ".pin";
  const SECTION_HANDLE = "lookbook-load-prod";
  const MOUNT_ID = "gdl-look-products-mount";

  let swiperInstance = null;
  let loadSeq = 0;
  let currentAbort = null;
  let lastRealSlideIndex = null;

  const GLOBAL_LOADER_ID = "gdl-look-loader";

  function ensurePinPointerEventsCSS() {
    const id = "gdl-look-pin-pointer-events";
    if (document.getElementById(id)) return;

    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      .pin-products { pointer-events: none; }
      .pin { pointer-events: auto; }
    `;
    document.head.appendChild(style);
  }

  function ensureGlobalLoader() {
    let el = document.getElementById(GLOBAL_LOADER_ID);
    if (el) return el;

    el = document.createElement("div");
    el.id = GLOBAL_LOADER_ID;
    el.hidden = true;
    el.innerHTML = `
      <div class="gdl-look-loader__backdrop" aria-hidden="true"></div>
      <div class="gdl-look-loader__spinner" role="status" aria-live="polite" aria-label="Loading"></div>
    `;

    const style = document.createElement("style");
    style.textContent = `
      #${GLOBAL_LOADER_ID} { position: fixed; inset: 0; z-index: 99999; }
      #${GLOBAL_LOADER_ID}[hidden] { display: none; }
      #${GLOBAL_LOADER_ID} .gdl-look-loader__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(255,255,255,.6);
      }
      #${GLOBAL_LOADER_ID} .gdl-look-loader__spinner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 42px;
        height: 42px;
        border-radius: 50%;
        border: 3px solid rgba(0,0,0,.15);
        border-top-color: rgba(0,0,0,.6);
        animation: gdlspin .8s linear infinite;
      }
      @keyframes gdlspin {
        to { transform: translate(-50%, -50%) rotate(360deg); }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(el);

    return el;
  }

  function showGlobalLoader() {
    ensureGlobalLoader().hidden = false;
  }

  function hideGlobalLoader() {
    const el = document.getElementById(GLOBAL_LOADER_ID);
    if (el) el.hidden = true;
  }

  function getHandlesFromLook(lookEl) {
    return Array.from(lookEl.querySelectorAll(".pin-products[data-product]"))
      .map((el) => (el.getAttribute("data-product") || "").trim())
      .filter(Boolean);
  }

  function uniq(arr) {
    return Array.from(
      new Set((arr || []).map((s) => (s || "").trim()).filter(Boolean)),
    );
  }

  async function fetchQuickviewHTML(handle, signal) {
    const res = await fetch(
      `${window.Shopify.routes.root}products/${handle}?view=lookbook-quickview`,
      {
        credentials: "same-origin",
        signal,
      }
    );

    if (!res.ok) {
      throw new Error(`Quickview ${handle} -> ${res.status}`);
    }

    return res.text();
  }

  function ensureMount(sourceEl = null) {
    let mount = document.getElementById(MOUNT_ID);
    const footerSection = document.getElementById(
      "shopify-section-fostr-footer",
    );
    const sourceSection = sourceEl?.closest('[id^="shopify-section-"]');

    if (mount) {
      if (footerSection && mount.nextElementSibling !== footerSection) {
        footerSection.parentNode.insertBefore(mount, footerSection);
      }
      return mount;
    }

    mount = document.createElement("div");
    mount.id = MOUNT_ID;

    if (footerSection && footerSection.parentNode) {
      footerSection.parentNode.insertBefore(mount, footerSection);
    } else if (sourceSection && sourceSection.parentNode) {
      sourceSection.parentNode.insertBefore(mount, sourceSection.nextSibling);
    } else {
      document.body.appendChild(mount);
    }

    return mount;
  }

  async function fetchAndRenderSection(sourceEl = null) {
    const mount = ensureMount(sourceEl);

    const existing = mount.querySelector("[data-gdl-look-products]");
    if (existing) return existing;

    const url = `/?sections=${encodeURIComponent(SECTION_HANDLE)}`;
    const res = await fetch(url, { credentials: "same-origin" });

    if (!res.ok) {
      throw new Error(`Sections fetch failed: ${res.status}`);
    }

    const json = await res.json();
    const html = json?.[SECTION_HANDLE];

    if (!html) {
      throw new Error(`Section "${SECTION_HANDLE}" non trovata`);
    }

    mount.innerHTML = html;

    const sectionEl = mount.querySelector("[data-gdl-look-products]");
    if (!sectionEl) {
      throw new Error("Manca [data-gdl-look-products]");
    }

    wireModal(sectionEl);
    sectionEl.hidden = true;

    return sectionEl;
  }

  function setStatus(sectionEl, text = "", show = true) {
    const wrap = sectionEl.querySelector("[data-status]");
    const txt = sectionEl.querySelector("[data-status-text]");
    if (!wrap || !txt) return;

    txt.textContent = text;
    wrap.hidden = !show;
  }

  function openModal(sectionEl) {
    sectionEl.hidden = false;
    document.documentElement.classList.add("overflow-hidden");

    const closeBtn = sectionEl.querySelector("[data-close]");
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(sectionEl) {
    sectionEl.hidden = true;
    document.documentElement.classList.remove("overflow-hidden");

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    if (sectionEl._keyHandler) {
      document.removeEventListener("keyup", sectionEl._keyHandler);
    }
  }

  window.initLookQuickviewAddToCartMessage = function (root) {
    const wrap = root.querySelector(".gdl-look-quickview");
    if (!wrap) return;

    const form = wrap.querySelector('form[data-type="add-to-cart-form"]');
    const addcartMessage = wrap.querySelector("[data-addcart-message]");

    if (!form || !addcartMessage) return;
    if (form.dataset.addcartMessageBound === "true") return;

    form.dataset.addcartMessageBound = "true";
    addcartMessage.classList.add("hidden");

    form.addEventListener("submit", () => {
      const variantInput =
        form.querySelector("[data-variant-input]") ||
        form.querySelector('input[name="id"]');

      wrap.dataset.lastSubmittedVariantId = variantInput?.value?.trim() || "";

      const cartDrawer = document.querySelector("cart-drawer");
      if (form.dataset.addToCartSource === "lookbook") {
        window.__skipLookbookCartOpen = true;

        if (cartDrawer) {
          cartDrawer.dataset.skipOpen = "true";
        }
      }
    });
  };

  window.resetLookQuickview = function (scope = document) {
    const quickviews = scope.querySelectorAll(".gdl-look-quickview");

    quickviews.forEach((wrap) => {
      const optionRadios = wrap.querySelectorAll(
        'input[type="radio"][data-variant]',
      );

      const fakeNotify = wrap.querySelector("[data-fake-nofify]");
      const messagesize = wrap.querySelector("[data-selectvariant-message]");


      optionRadios.forEach((radio) => {
        radio.checked = false;
      });

      wrap
        .querySelectorAll("label.product-option__variant.selected")
        .forEach((label) => {
          label.classList.remove("selected");
        });

      const hiddenVariantInput =
        wrap.querySelector("[data-variant-input]") ||
        wrap.querySelector('input[name="id"]');

      if (hiddenVariantInput) {
        hiddenVariantInput.value = "";
      }

      wrap.dataset.lastSubmittedVariantId = "";

      const submitButton = wrap.querySelector("[data-submit]");
      const submitButtonSpan = submitButton?.querySelector("span");
      const productLinkWrap = wrap.querySelector("[data-link-prod]");
      const bisContainer = wrap.querySelector("[data-bis-container]");
      const addcartMessage = wrap.querySelector("[data-addcart-message]");
      const prodmessagesize = wrap.querySelector("[data-prodselectsize-message]");


      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.remove("hidden");
      }

      addcartMessage?.classList.add("hidden");
      fakeNotify?.classList.remove("hidden");
      productLinkWrap?.classList.remove("hidden");
      bisContainer?.classList.add("hidden");
      prodmessagesize?.classList.add("hidden");
      messagesize?.classList.add("hidden");
    });
  };

  window.initLookQuickview = function (root) {
    const wrap = root.querySelector(".gdl-look-quickview");
    if (!wrap) return;

    const optionRadios = wrap.querySelectorAll(
      'input[type="radio"][data-variant]',
    );

    const submitButton = wrap.querySelector("[data-submit]");
    const productLinkWrap = wrap.querySelector("[data-link-prod]");
    const bisContainer = wrap.querySelector("[data-bis-container]");
    const fakeNotify = wrap.querySelector("[data-fake-nofify]");
    const messagesize = wrap.querySelector("[data-selectvariant-message]");
    const prodmessagesize = wrap.querySelector("[data-prodselectsize-message]");
    const addcartMessage = wrap.querySelector("[data-addcart-message]");

    function updateAvailabilityState(radio) {
      const label = wrap.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      const isUnavailable = label?.classList.contains("unavailable");

      if (isUnavailable) {
        submitButton?.classList.add("hidden");
        productLinkWrap?.classList.add("hidden");
        bisContainer?.classList.remove("hidden");
        fakeNotify?.classList.add("hidden");
        messagesize?.classList.add("hidden");
      } else {
        submitButton?.classList.remove("hidden");
        productLinkWrap?.classList.remove("hidden");
        bisContainer?.classList.add("hidden");
        fakeNotify?.classList.remove("hidden");
        messagesize?.classList.add("hidden");
      }
    }

    if (fakeNotify && messagesize) {
      fakeNotify.addEventListener("click", () => {
        messagesize.classList.remove("hidden");
      });
    }

    const buttonsWrap = wrap.querySelector(".product-form__buttons");
    if (buttonsWrap && !buttonsWrap.dataset.bound) {
      buttonsWrap.dataset.bound = "true";

      buttonsWrap.addEventListener("click", (e) => {
        if (!submitButton) return;
        if (submitButton.disabled) {
          const isHidden = submitButton.classList.contains("hiddenbt");
          if (isHidden || !prodmessagesize) return;

          e.preventDefault();
          e.stopPropagation();

          prodmessagesize.classList.remove("hidden");
        }
      });
    }

    optionRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateAvailabilityState(radio);
        addcartMessage?.classList.add("hidden");
        messagesize?.classList.add("hidden");
        prodmessagesize?.classList.add("hidden");
      });
    });

    const checkedRadio = wrap.querySelector(
      'input[type="radio"][data-variant]:checked',
    );

    if (checkedRadio) {
      updateAvailabilityState(checkedRadio);
    } else {
      submitButton?.classList.remove("hidden");
      productLinkWrap?.classList.remove("hidden");
      bisContainer?.classList.add("hidden");
      fakeNotify?.classList.remove("hidden");
    }
  };

  function wireModal(sectionEl) {
    const overlay = sectionEl.querySelector("[data-overlay]");
    const closeBtn = sectionEl.querySelector("[data-close]");

    overlay?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeModal(sectionEl);
    });

    closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeModal(sectionEl);
    });

    const keyHandler = (e) => {
      if (sectionEl.hidden) return;

      if (e.key === "Escape") {
        closeModal(sectionEl);
      } else if (e.key === "ArrowLeft" && swiperInstance) {
        swiperInstance.slidePrev();
      } else if (e.key === "ArrowRight" && swiperInstance) {
        swiperInstance.slideNext();
      }
    };

    document.addEventListener("keyup", keyHandler);
    sectionEl._keyHandler = keyHandler;
  }

  function clearSlides(sectionEl) {
    const wrapper = sectionEl.querySelector("[data-wrapper]");
    if (wrapper) wrapper.innerHTML = "";
  }

  function renderSlidesHTML(sectionEl, htmlList) {
    const wrapper = sectionEl.querySelector("[data-wrapper]");
    if (!wrapper) throw new Error("Manca [data-wrapper]");

    wrapper.innerHTML = "";

    htmlList.forEach((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const quickview = doc.querySelector(".gdl-look-quickview");

      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.innerHTML = quickview ? quickview.outerHTML : html;

      wrapper.appendChild(slide);

      window.initLookQuickview?.(slide);
      window.initLookQuickviewAddToCartMessage?.(slide);
      window.initLookbookBIS?.(slide);
    });
  }

  function initSwiper(sectionEl, startIndex = 0) {
    if (!window.Swiper) {
      console.error("[LOOKBOOK] Swiper non presente");
      return;
    }

    const swiperEl = sectionEl.querySelector("[data-swiper]");
    const nextEl = sectionEl.querySelector("[data-next]");
    const prevEl = sectionEl.querySelector("[data-prev]");
    const paginationEl = sectionEl.querySelector("[data-pagination]");
    const numberlook = sectionEl.querySelector("[data-number-look]");
    const progressBar = sectionEl.querySelector("[data-progress-bar]");
    const progressWrap = progressBar?.parentElement;

    if (!swiperEl) {
      throw new Error("Manca [data-swiper]");
    }

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    function updateLook(sw) {
      const current = sw.realIndex + 1;
      if (numberlook) {
        numberlook.textContent = `Look ${current}`;
      }
    }

    function updateProgress(sw) {
      if (!progressBar) return;

      const total = sw.slides?.length || 1;

      if (progressWrap) {
        progressWrap.classList.toggle("hidden", total <= 1);
      }

      if (total <= 1) return;

      const current = sw.realIndex ?? sw.activeIndex ?? 0;
      const trackWidth = progressWrap.offsetWidth;
      const thumbWidth = trackWidth / total;
      const x = thumbWidth * current;

      progressBar.style.width = `${thumbWidth}px`;
      progressBar.style.transform = `translate3d(${x}px, -50%, 0)`;
    }

    swiperInstance = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      navigation: { nextEl, prevEl },
      pagination: { el: paginationEl, type: "fraction" },
      speed: 350,
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
      on: {
        init(sw) {
          sw.update();
          updateProgress(sw);
          updateLook(sw);
          lastRealSlideIndex = sw.realIndex;
        },
        slideChange(sw) {
          updateProgress(sw);
          updateLook(sw);

          if (lastRealSlideIndex === sw.realIndex) return;
          lastRealSlideIndex = sw.realIndex;

          const swiperContainer =
            sw.el?.closest("[data-gdl-look-products]") || document;

          window.resetLookQuickview?.(swiperContainer);
        },
        slidesLengthChange(sw) {
          updateProgress(sw);
        },
      },
    });

    requestAnimationFrame(() => {
      if (!swiperInstance) return;

      swiperInstance.update();
      const idx = Number.isFinite(startIndex) ? Math.max(0, startIndex) : 0;
      swiperInstance.slideTo(idx, 0);
    });
  }

  async function loadLookProducts(
    handles,
    initialHandle = null,
    sourceEl = null,
  ) {
    const sectionEl = await fetchAndRenderSection(sourceEl);
    const uniqueHandles = uniq(handles);

    if (!uniqueHandles.length) return;

    loadSeq += 1;
    const seq = loadSeq;

    if (currentAbort) currentAbort.abort();
    currentAbort = new AbortController();

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    clearSlides(sectionEl);
    setStatus(sectionEl, "Carico i prodotti…", true);
    showGlobalLoader();

    try {
      const htmlList = await Promise.all(
        uniqueHandles.map((h) => fetchQuickviewHTML(h, currentAbort.signal)),
      );

      renderSlidesHTML(sectionEl, htmlList);

      if (seq !== loadSeq) return;

      let startIndex = 0;
      if (initialHandle) {
        const i = uniqueHandles.indexOf(initialHandle);
        startIndex = i >= 0 ? i : 0;
      }

      initSwiper(sectionEl, startIndex);
      setStatus(sectionEl, "", false);
      openModal(sectionEl);
    } catch (err) {
      if (err?.name === "AbortError") return;

      console.error("[LOOKBOOK]", err);
      setStatus(sectionEl, "Errore nel caricamento prodotti", true);
    } finally {
      if (seq === loadSeq) hideGlobalLoader();
    }
  }

  document.addEventListener("click", (e) => {
    const look = e.target.closest(LOOK_SELECTOR);
    if (!look) return;

    const pinProducts =
      e.target.closest(PIN_SELECTOR)?.closest(".pin-products[data-product]") ||
      null;

    if (pinProducts) {
      loadLookProducts(
        getHandlesFromLook(look),
        pinProducts.getAttribute("data-product"),
        look,
      );
      return;
    }

    loadLookProducts(getHandlesFromLook(look), null, look);
  });

  ensurePinPointerEventsCSS();
})();

(function bindLookbookAddToCartMessageListener() {
  if (window.__lookbookAddToCartMessageListenerInit) return;
  window.__lookbookAddToCartMessageListenerInit = true;

  const hideTimers = new WeakMap();

  document.addEventListener("lookbook:add-to-cart-success", (event) => {
    const addedVariantId = String(event.detail?.variantId || "");
    if (!addedVariantId) return;

    document.querySelectorAll(".gdl-look-quickview").forEach((wrap) => {
      const submittedVariantId = String(
        wrap.dataset.lastSubmittedVariantId || "",
      );
      const addcartMessage = wrap.querySelector("[data-addcart-message]");

      if (!addcartMessage) return;
      if (!submittedVariantId) return;
      if (submittedVariantId !== addedVariantId) return;

      const oldTimer = hideTimers.get(addcartMessage);
      if (oldTimer) clearTimeout(oldTimer);

      addcartMessage.classList.remove("hidden");

      const timer = setTimeout(() => {
        addcartMessage.classList.add("hidden");
      }, 3000);

      hideTimers.set(addcartMessage, timer);
    });
  });
})();

(function watchLookbookAddToCart() {
  if (window.__lookbookCartWatcherInit) return;
  window.__lookbookCartWatcherInit = true;

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const [input, init] = args;
    const response = await originalFetch.apply(this, args);

    try {
      const url =
        typeof input === "string"
          ? input
          : input instanceof Request
            ? input.url
            : "";

      const isCartAdd =
        url.includes("/cart/add.js") || /\/cart\/add(\?|$)/.test(url);

      if (!isCartAdd) return response;
      if (!response.ok) return response;

      let variantId = null;

      if (init?.body instanceof FormData) {
        variantId = init.body.get("id");
      } else if (typeof init?.body === "string") {
        const params = new URLSearchParams(init.body);
        variantId = params.get("id");
      } else if (init?.body) {
        try {
          const parsed = JSON.parse(init.body);
          variantId = parsed.id || parsed.items?.[0]?.id || null;
        } catch (e) {}
      }

      let addedItem = null;
      try {
        const cloned = response.clone();
        const json = await cloned.json();
        addedItem = Array.isArray(json?.items) ? json.items[0] : json;

        if (!variantId) {
          variantId = addedItem?.variant_id || addedItem?.id || null;
        }
      } catch (e) {}

      document.dispatchEvent(
        new CustomEvent("lookbook:add-to-cart-success", {
          detail: {
            variantId: variantId ? String(variantId) : null,
            item: addedItem || null,
            url,
          },
        }),
      );
    } catch (e) {
      console.warn("[LOOKBOOK] cart watcher error", e);
    }

    return response;
  };
})();

//KLAvyo chiamta



window.initLookbookBIS = function (root) {
  const wrap = root.matches?.("[data-bis-container].gdl-look-quickview")
    ? root
    : root.querySelector("[data-bis-container].gdl-look-quickview");

  if (!wrap) {
    console.log("[LOOKBOOK BIS] wrap non trovato");
    return;
  }

  const bisEmailInput = wrap.querySelector("[data-bis-email]");
  const bisMarketingConsent = wrap.querySelector("[data-bis-marketing-consent]");
  const bisSubmitButton = wrap.querySelector("[data-bis-submit]");
  const bisMessage = wrap.querySelector("[data-bis-message]");

  console.log("[LOOKBOOK BIS] wrap trovato:", wrap);
  console.log("[LOOKBOOK BIS] attrs:", {
    invalidEmail: wrap.getAttribute("data-bis-text-invalid-email"),
    selectVariant: wrap.getAttribute("data-bis-text-select-variant"),
    success: wrap.getAttribute("data-bis-text-success"),
    successMarketing: wrap.getAttribute("data-bis-text-success-marketing"),
    error: wrap.getAttribute("data-bis-text-error"),
  });

  if (!bisSubmitButton || !bisEmailInput || !bisMessage) {
    console.log("[LOOKBOOK BIS] elementi BIS mancanti");
    return;
  }

  // reset bind vecchio se stai facendo test
  bisSubmitButton.dataset.bisBound = "false";

  if (bisSubmitButton.dataset.bisBound === "true") {
    console.log("[LOOKBOOK BIS] già bindato");
    return;
  }
  bisSubmitButton.dataset.bisBound = "true";

  const bisTexts = {
    invalidEmail: wrap.getAttribute("data-bis-text-invalid-email") || "",
    selectVariant: wrap.getAttribute("data-bis-text-select-variant") || "",
    success: wrap.getAttribute("data-bis-text-success") || "",
    successMarketing: wrap.getAttribute("data-bis-text-success-marketing") || "",
    error: wrap.getAttribute("data-bis-text-error") || "",
  };

  console.log("[LOOKBOOK BIS] testi risolti:", bisTexts);

  const KLAVIYO_COMPANY_ID = "X5Sgey";
  const KLAVIYO_LIST_ID = "XUL5JQ";

  function setBisLoading(isLoading) {
    bisSubmitButton.disabled = isLoading;
    bisSubmitButton.setAttribute("aria-disabled", isLoading ? "true" : "false");
  }

  function setBisFeedback(message, type = "info") {
    console.log("[LOOKBOOK BIS] feedback:", { message, type });
    bisMessage.textContent = message || "";
    bisMessage.setAttribute("data-type", type);
    bisMessage.classList.toggle("hidden", !message);
  }

  function getSelectedVariantId() {
    const checkedRadio = root.querySelector(
      'input[type="radio"][data-variant]:checked'
    );

    if (checkedRadio?.dataset?.variant) {
      return checkedRadio.dataset.variant.trim();
    }

    const dataVariantInput = root.querySelector("[data-variant-input]");
    const formVariantInput = root.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );

    return (
      dataVariantInput?.value?.trim() ||
      formVariantInput?.value?.trim() ||
      ""
    );
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  async function subscribeBackInStock(email, variantId) {
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          channels: ["EMAIL"],
          profile: {
            data: {
              type: "profile",
              attributes: { email },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-06-15",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "BIS_SUBSCRIPTION_FAILED");
    }

    return response;
  }

  async function subscribeMarketing(email) {
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Lookbook back in stock",
          profile: {
            data: {
              type: "profile",
              attributes: { email },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: KLAVIYO_LIST_ID,
            },
          },
        },
      },
    };

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-07-15",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || "MARKETING_SUBSCRIPTION_FAILED");
    }

    return response;
  }

  bisSubmitButton.addEventListener("click", async () => {
    const email = bisEmailInput.value.trim();
    const variantId = getSelectedVariantId();
    const hasMarketingConsent = !!bisMarketingConsent?.checked;

    console.log("[LOOKBOOK BIS] submit", {
      email,
      variantId,
      hasMarketingConsent,
      texts: bisTexts,
    });

    if (!email || !isValidEmail(email)) {
      setBisFeedback(bisTexts.invalidEmail, "error");
      return;
    }

    if (!variantId) {
      setBisFeedback(bisTexts.selectVariant, "error");
      return;
    }

    setBisLoading(true);
    setBisFeedback("", "info");

    try {
      await subscribeBackInStock(email, variantId);

      if (hasMarketingConsent) {
        await subscribeMarketing(email);
      }

      setBisFeedback(
        hasMarketingConsent ? bisTexts.successMarketing : bisTexts.success,
        "success"
      );

      bisEmailInput.value = "";
      if (bisMarketingConsent) bisMarketingConsent.checked = false;
    } catch (error) {
      console.error("[LOOKBOOK BIS] catch:", error);
      setBisFeedback(bisTexts.error, "error");
    } finally {
      setBisLoading(false);
    }
  });
};